var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerprintSvgrepocom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2344 44.3071L22.8302 38.555C23.8962 36.8487 24.6443 34.9634 25.0385 32.9905L25.1615 32.3842C25.3766 31.3072 25.4847 30.2116 25.4844 29.1134V25.5571M6.73438 32.8488C7.77604 30.7655 8.81771 28.5925 8.81771 25.5571C8.81771 21.9321 9.97604 18.5738 11.9427 15.8384M11.9427 39.0988C16.1094 34.9321 17.151 28.1884 17.151 25.5571C17.1483 23.4555 17.9399 21.4304 19.367 19.8876C20.7942 18.3448 22.7516 17.3982 24.8471 17.2375C26.9427 17.0768 29.0215 17.7138 30.6673 19.0209C32.313 20.3281 33.4041 22.2088 33.7219 24.2863M41.1094 37.0155C42.151 32.8488 42.151 28.6821 42.151 25.5571C42.1517 22.6312 41.3821 19.7567 39.9195 17.2225C38.457 14.6883 36.3531 12.5838 33.8193 11.1206C31.2856 9.65732 28.4112 8.88688 25.4853 8.88672C22.5594 8.88655 19.685 9.65667 17.151 11.1196M33.7219 31.8071C33.3594 34.7092 32.3344 38.4342 29.651 43.2655",
    stroke: "#383838",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintSvgrepocom);
export default __webpack_public_path__ + "static/media/fingerprint_svgrepo.com.f87b99c34d7127867299987ba18ea2f0.svg";
export { ForwardRef as ReactComponent };